import useMediaQuery from '@material-ui/core/useMediaQuery';
import { colors } from '@skyslope/mache';
import React, { useEffect, useState } from 'react';
import SignatureCanvas from 'react-canvas-draw';
import { IS_MOBILE } from '../../common/constants';

type Dimension = {
  width: number;
  height: number;
};

const getDimensions = (rect: Dimension) => ({ height: rect.height, width: rect.width });

export const CanvasWrapper = React.forwardRef(
  (
    props: {
      onEnd: () => void;
      canvasProps: any;
      hasContent: boolean;
      ['data-spec']: string;
      canvasWidth: number;
      setMaxWidth: (width: number) => void;
    },
    ref
  ) => {
    const [canvasSizeData, setData] = useState({ newDimensions: undefined });
    const [canvasWidth, setCanvasWidth] = useState(0);
    const landscapeMediaQuery = useMediaQuery('(orientation: landscape)');
    const showExtendedCanvas = canvasWidth && props.hasContent && !landscapeMediaQuery && IS_MOBILE;
    useEffect(() => {
      if (ref.current.canvas.drawing.clientWidth > canvasWidth) {
        setCanvasWidth(ref.current.canvas.drawing.clientWidth);
        props.setMaxWidth(ref.current.canvas.drawing.clientWidth);
      }
    }, [landscapeMediaQuery]);

    useEffect(() => {
      if (!props.hasContent) {
        setCanvasWidth(null);
      }
    }, [props.hasContent]);
    const onChange = () => {
      if (ref?.current?.canvas?.temp) {
        const drawingData = JSON.parse(ref.current.getSaveData());
        if (canvasSizeData.drawingData) {
          if (drawingData.lines.length !== 0 && canvasSizeData.drawingData.lines.length > drawingData.lines.length) {
            const data = {
              newDimensions: getDimensions(ref.current.canvas.temp),
              oldDimensions: canvasSizeData.newDimensions,
              drawingData,
            };
          } else {
            const data = {
              newDimensions: getDimensions(ref.current.canvas.temp),
              oldDimensions: canvasSizeData.newDimensions,
              drawingData,
            };
            setData(data);
          }
        } else {
          const data = {
            newDimensions: getDimensions(ref.current.canvas.temp),
            oldDimensions: canvasSizeData.newDimensions,
            drawingData,
          };
          setData(data);
        }
      }
      props.onEnd();
    };
    console.log('Rendering, ', props['data-spec'], 'with width of, ', props.canvasWidth);
    return (
      <SignatureCanvas
        hideInterface={true}
        ref={ref}
        style={{
          width: showExtendedCanvas ? props.canvasWidth : '100%',
          height: '172px',
          position: 'relative',
          border: showExtendedCanvas ? `1px solid ${colors.grey[800]}` : '',
        }}
        onChange={onChange}
        brushRadius={2}
        brushColor={'#000'}
        hideGrid
        lazyRadius={0}
        data-spec={`${props['data-spec']}-draw`}
      />
    );
  }
);
